<div class="add-edit-customer-form">
  @if (showSubTitle) {
    @if (!showAddedUser && !showExistedUser && !isEdit) {
      <p>
        The term customer means the person for whom you are placing bids. This is not to be considered a legal real estate term defining a client or customer
        agency relationship. The legal representation of the bidder is for you and the bidder to decide.
      </p>
      <h5 class="mt-4">New customer registration</h5>
    }
    @if (showAddedUser && !isEdit) {
      <div><span>The new customer has been added and can be managed from the </span><span style="font-weight: bold">My Customers</span> page</div>
      <h5 class="mt-4">Customer details</h5>
    }
    @if (showExistedUser && !isEdit) {
      <p-message severity="warn" class="g-0 mb-4" text="Customer already exists and can be managed from the My Customers page." />
      <h5 class="mt-4">Customer details</h5>
    }
  }

  <div>
    <form [formGroup]="form" [ngClass]="{ 'show-errors-on-touched': errorCondition.touch }">
      @if (!showAddedUser && !showExistedUser) {
        <div>
          @for (field of formFields; track field) {
            <p>
              @if (field.label) {
                <label [for]="field.formControlName || ''">
                  {{ field.label || field.placeholder || '' }}
                </label>
              }
              @switch (field.type) {
                @case ('inputmask') {
                  <p-inputMask
                    [id]="field.formControlName || ''"
                    [formControlName]="field.formControlName || ''"
                    [mask]="field.mask || ''"
                    [slotChar]="field.slotChar || ' '"
                    [placeholder]="field.placeholder || ''" />
                }
                @default {
                  <input
                    [formControlName]="field.formControlName || ''"
                    [placeholder]="field.placeholder || ''"
                    [type]="field.type || 'text'"
                    [id]="field.formControlName || ''"
                    pInputText />
                }
              }
              <app-input-error
                [controlName]="field.formControlName || ''"
                [friendlyName]="field.label || field.placeholder || ''"
                [errorCondition]="errorCondition"
                [anyErrorShowInvalid]="field.anyErrorShowInvalid || false"
                [customErrorMessage]="field.customErrorMessage || null" />
            </p>
          }
        </div>
      }

      @if ((showAddedUser || showExistedUser) && !isEdit) {
        <div>
          <div>
            <span class="mr-5 label">Customer Name:</span>
            <span class="mr-5">{{ form.controls['FIRST_NAME'].value }}</span>
            <span>{{ form.controls['LAST_NAME'].value }}</span>
          </div>
          <div>
            <span class="mr-5 label">Customer ID:</span>
            <span>{{ form.controls['CUSTOMER_ID'].value }}</span>
          </div>
          <div>
            <span class="mr-5 label">Screen Name:</span>
            <span>RB{{ form.controls['CUSTOMER_ID'].value }}</span>
          </div>
          <div>
            <span class="mr-5 label">Phone Number:</span>
            <span>{{ form.controls['CELL_PHONE'].value | phoneNumber }}</span>
          </div>
        </div>
      }
    </form>
  </div>
</div>
